import React, { useState } from "react";
import styles from "./Header.module.css";

interface HeaderProps {
  onClose?: () => void;
  onHelp?: () => void;
  onRefresh?: () => void | Promise<void>;
  onBack?: () => void;
  onLogout?: () => void;
}

function BackIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 12H5" />
      <path d="M12 19l-7-7 7-7" />
    </svg>
  );
}

function RefreshIcon({ spinning }: { spinning: boolean }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={spinning ? styles.spin : ""}
    >
      <path d="M23 4v6h-6" />
      <path d="M1 20v-6h6" />
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10" />
      <path d="M20.49 15a9 9 0 0 1-14.85 3.36L1 14" />
    </svg>
  );
}

export default function Header({ onClose, onHelp, onRefresh, onBack }: HeaderProps) {
  const [spinning, setSpinning] = useState(false);

  const handleRefresh = async () => {
    if (!onRefresh || spinning) return;
    setSpinning(true);
    try {
      await onRefresh();
    } finally {
      setTimeout(() => setSpinning(false), 600);
    }
  };

  return (
    <div className={styles.header}>
      <div className={styles.left}>
        {onBack && (
          <button
            type="button"
            className={styles.iconBtn}
            onClick={onBack}
            aria-label="Back"
            title="Back"
          >
            <BackIcon />
          </button>
        )}
      </div>

      <div className={styles.iconGroup}>
        {onRefresh && (
          <button
            type="button"
            className={styles.iconBtn}
            onClick={handleRefresh}
            aria-label="Refresh"
            title="Refresh email context"
            disabled={spinning}
          >
            <RefreshIcon spinning={spinning} />
          </button>
        )}
        {onHelp && (
          <button
            type="button"
            className={styles.iconBtn}
            onClick={onHelp}
            aria-label="Help"
            title="Help"
          >
            ?
          </button>
        )}
        {onClose && (
          <button
            type="button"
            className={styles.iconBtn}
            onClick={onClose}
            aria-label="Close"
            title="Close"
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
}
